import React from 'react';
import { Image } from 'semantic-ui-react';
import { CONFIG } from '../../../helper/config';
import './error-boundary.css';
import { IMAGECONFIG } from '../../../helper/image-config';

/**
 * Props for the {@link ErrorFallback} component.
 *
 * Currently, the component does not accept any props,
 * but this interface is defined for future extensibility.
 */
interface ErrorFallbackProps {}

/**
 * A fallback UI component displayed when an error occurs
 * within a React error boundary.
 *
 * This component shows an error illustration along with
 * primary and secondary fallback messages defined in the config.
 *
 * @component
 * @example
 * ```tsx
 * <ErrorFallback />
 * ```
 */
const ErrorFallback: React.FC<ErrorFallbackProps> = () => {
  return (
    <div id='error-container'>
      <div className='fallback-ui'>
        <Image src={IMAGECONFIG.ERRORFALLBACK} className='fallback-img' />
        <div className='fallback-message'>
          <div className='fallback-first-message'>{CONFIG.FALLBACKFIRSTMESSAGE}</div>
          <div className='fallback-second-message'>{CONFIG.FALLBACKSECONDMESSAGE}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;